var $ = require('jquery');
if(window.location.href.indexOf('funddetail')==-1 && window.location.href.toLocaleLowerCase().indexOf('faqs')==-1 && window.location.href.toLocaleLowerCase().indexOf('press-releases')==-1 && window.location.href.toLocaleLowerCase().indexOf('notices')==-1)
{
$(function(){   
    $(".sec-nav-list li a").click(function()
    {
       var awardVal = $(this).attr('data-value');
       var link=$(this).attr('href');
       if(awardVal == 'all' && link==undefined)
       {
        $(".list-border-left").removeClass('hidden');
       }
       else if(link==undefined)
       {
        $(".list-border-left").addClass('hidden');
        $('.' + awardVal).removeClass('hidden');
       }    
       
       $('.awards-section').each(function()                          
       {
            var hiddenitems = $(this).find('.hidden').length;
            var totalitems = $(this).find('.list-border-left').length;
            if(hiddenitems == totalitems)
            {
                $(this).hide();
            }
                else
            {
                $(this).show();
            }
            });
            var pagehiddenitems = $('.awards-section').find('.hidden').length;
            var pagetotalitems = $('.awards-section').find('.list-border-left').length;
               
                if(pagehiddenitems == pagetotalitems)
                {
                $('.data-not-found').show();                
                }
                else
                {
                    $('.data-not-found').hide(); 
                }            
        });
});

$(function(){   
    $(".tab-scroll-awards li a").click(function()
    {
        var link=$(this).attr('href');
        if(link==undefined || link=='')
        {
            $(".tab-scroll-awards li a").removeClass('active');
            $(this).addClass('active');  
        }
    });
});
}


    // babu added 27-09-2022

    $(document).ready(function () {
        var isload = true;
        var mainskip = 10, take = 0;
        var endyear=$('.awards-lastdivendYyear').val();
        var country=$('.awards-country').val();
        //$(window).scroll(function () {
        //    if ($(window).scrollTop() > (Number($("#Divloadmoreawards").height()) / 2)) {
        //        if (isload == true) {
        //            loadPageData(mainskip, take);
        //            isload = false;
        //        }
        //    }
        //});

        if($('.awards-country').length>0 && $('.awards-country')!=undefined){
            setTimeout(function () {
                if(country.toLocaleLowerCase()=="global")
                {
                    loadPageData(mainskip, take,endyear);
                    if(window.location.href.indexOf("com/about-us/awards")>-1)
                        {
                            $(".sec-nav-list li a[data-value='regional']").click();
                        }
                }
                
            }, 1000);

        }
        
        setTimeout(function () {
                if(window.location.href.indexOf("com/about-us/awards")>-1)
                    {
                        $(".sec-nav-list li a[data-value='regional']").click();
                    }
        }, 3000);
        if(window.location.href.indexOf("eastspringth")>-1 ||window.location.href.indexOf("co.th")>-1)
        {
            $(".sec-nav-list li a[data-value='TMBAM']").click();
        }

if(window.location.href.indexOf("/sg/")>-1)
                    {
                        $(".sec-nav-list li a[data-value='singapore']").click();
                    }
                    if(window.location.href.indexOf("/hk/")>-1)
                    {
                        var url = window.location.href;
    var arr = url.split('#')[1];
    if(arr==undefined || arr=='')
    {
        $(".sec-nav-list li a[data-value='hongkong']").click();
    }
    else{
        arr=arr.toLocaleLowerCase();
            $(".sec-nav-list li a[data-value="+arr+"]").click();
    }
                       
                    }
                    

       function loadPageData(skip, take,lastendyear) {
            var url = window.location.pathname + "/GetMoreAwards";
            $.ajax({
                url: url,
                method: 'post',
                dataType: "html",
                data: { skip: skip, take: take,lastEndYear:lastendyear},
                success: function (response) {
                    if (response.length > 0) {
                        var insightsresult = response;
                        if (insightsresult != null && insightsresult != undefined) {
                            var startlastyearindex = insightsresult.indexOf("<!-- awards incomplete year start -->");
                                var endlastyearindex = insightsresult.indexOf("<!-- awards incomplete year end -->");
                                var res1 = insightsresult.substring(startlastyearindex, endlastyearindex);
                                $('.awardsmorelastyear').html('');
                                $('.awardsmorelastyear').html(res1);
                            var strtindex = insightsresult.indexOf("<!-- awards  start -->");
                            var endindex = insightsresult.indexOf("<!-- awards  end -->");
                            var res = insightsresult.substring(strtindex, endindex);
                            $('.awardsmore').html('');
                            $('.awardsmore').html(res);
                           
                        }
                        return true;
                    }
                },
                error: function (err) {
                },
                complete: function () {
                    // if(window.location.href.indexOf("/sg/")>-1)
                    // {
                    //     $(".sec-nav-list li a[data-value='singapore']").click();
                    // }
                }
            });
        }
    });
    